import * as React from 'react';

interface Props {}

export const AlohaSVG: React.SFC<Props> = ({}) => {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="12.5" width="63" height="39" stroke="#333333" />
      <line x1="40.5" y1="12" x2="40.5" y2="52" stroke="black" />
      <rect x="8" y="40" width="14" height="1" fill="#333333" />
      <rect x="8" y="43" width="9" height="1" fill="#333333" />
      <rect x="45" y="33" width="14" height="1" fill="#333333" />
      <rect x="47" y="30" width="10" height="1" fill="#333333" />
    </svg>
  );
};
